/**
 * @fileoverview Carga las brechas + statements al entrar a la pantalla
 * de votación. Si ya están en el contexto, no las recarga.
 */

import { useEffect } from "react";

import { useParticipacion } from "../context/ParticipacionContext";

export function useBrechas() {
    const { state, cargarBrechas } = useParticipacion();

    useEffect(() => {
        if (state.session_token && state.brechas.length === 0 && !state.cargando_brechas) {
            cargarBrechas();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.session_token, state.brechas.length]);

    return {
        brechas: state.brechas,
        cargando: state.cargando_brechas,
        error: state.error,
    };
}
